/* eslint-disable no-underscore-dangle */

import user from '@99designs/ddo/models/user';
import designComment from '@99designs/ddo/models/designComment';
import propertyOrNull from '@99designs/utils/app/propertyOrNull';
import design from './design';

// Translate from Projects HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        id: propertyOrNull(json._links.self, 'href'),
        designId: propertyOrNull(json._embedded.design, 'design_id'),
        message: json.message,
        formattedMessage: json.formattedMessage,
        isDeleted: json.isDeleted,
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            edit: propertyOrNull(json._links.edit, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'),
        },
        createdAt: json.createdAt,
        creator: user.fromJSON(json._embedded.creator),
        permission: json._embedded.permission || {},
        design: design.fromJSON(json._embedded.file),
    };
}

export default Object.assign({}, designComment, { fromJSON });



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/models/designComment.js